import { Field, useFormikContext } from "formik";
import { useState } from "react";
import { OrderFormValues } from "../lib/contexts/FormikContext";
import { Product } from "../lib/types";
import { LunetSpinner } from "./LunetSpinner";

type Props = { selectedProducts: Product[] };

export const OrderSubmit = (props: Props) => {
  const { values, submitForm, setFieldValue, isSubmitting } =
    useFormikContext<OrderFormValues>();
  const [approvalError, setApprovalError] = useState<string>();
  const [policyError, setPolicyError] = useState<string>();
  const errorInputClasses = "border border-red-500";
  const errorMsgClasses = "text-red-500 text-sm";
  const { selectedProducts } = props;
  return (
    <>
      <label className="flex items-start gap-2">
        <Field type="checkbox" name="approval_details" className="mt-1.5" />
        <div>
          Jag har läst och förstått ovanstående information
          {approvalError && (
            <div className={errorMsgClasses}>{approvalError}</div>
          )}
        </div>
      </label>
      <label className="flex items-start gap-2 mb-4">
        <Field type="checkbox" name="approval_integrity" className="mt-1.5" />
        <div>
          Jag har läst och godkänner Lunets{" "}
          <a
            href="/wp-content/uploads/2023/06/lunets-integritetspolicy.pdf"
            target="_blank"
            className="color-[#374F5A] font-bold"
          >
            integritetspolicy
          </a>{" "}
          och tillåter att mina uppgifter sparas i Lunets system.
          {policyError && <div className={errorMsgClasses}>{policyError}</div>}
        </div>
      </label>
      {isSubmitting ? (
        <>
          <LunetSpinner />
        </>
      ) : (
        <>
          {selectedProducts[0].orderflow_type === "lime" ? (
            <>
              <button
                // onClick={() => alert("And off to Get Accept we go!")}
                type="button"
                onClick={() => {
                  if (!values.approval_integrity) {
                    setPolicyError(
                      "Du måste godkänna Lunets integritetspolicy"
                    );
                  } else {
                    setPolicyError("");
                  }
                  if (!values.approval_details) {
                    setApprovalError(
                      "Du måste markera att du har läst och förstått informationen ovan"
                    );
                  } else {
                    setApprovalError("");
                  }

                  if (values.approval_integrity && values.approval_details) {
                    setFieldValue("selectedProducts", selectedProducts);
                    submitForm();
                  }
                }}
                style={{ backgroundColor: "#374F5A" }}
                className="rounded-full px-4 py-2 text-white inline-block  text-sm"
              >
                Skicka in beställning
              </button>
            </>
          ) : (
            <>
              <button
                // onClick={() => alert("And off to Get Accept we go!")}
                type="button"
                onClick={() => {
                  if (!values.approval_integrity) {
                    setPolicyError(
                      "Du måste godkänna Lunets integritetspolicy"
                    );
                  } else {
                    setPolicyError("");
                  }
                  if (!values.approval_details) {
                    setApprovalError(
                      "Du måste markera att du har läst och förstått informationen ovan"
                    );
                  } else {
                    setApprovalError("");
                  }

                  if (values.approval_integrity && values.approval_details) {
                    setFieldValue("selectedProducts", selectedProducts);
                    submitForm();
                  }
                }}
                style={{ backgroundColor: "#374F5A" }}
                className="rounded-full px-4 py-2 text-white inline-block  text-sm"
              >
                Signera din beställning med BankID
              </button>
              <div className="mb-3 mt-8 max-w-md text-xs">
                Om du inte har BankID så kan du ändå skicka din beställning. Vi
                kommer att granska din beställning och återkomma med ett
                avtalsförslag till dig.
                <a
                  className="block bg-none mt-4 font-bold no-underline hover:underline text-[#374F5A]"
                  onClick={() => {
                    setFieldValue("selectedProducts", selectedProducts);
                    submitForm();
                  }}
                >
                  Skicka in beställning utan avtal
                </a>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};
